import { useMemo } from 'react';
import { WidgetDefinition } from '../../../../shared/types/widget';
import TabView, { Tab } from '../../OrgDim/TabView';
import WidgetRenderer from './WidgetRenderer';

type Props = {
  widgets: WidgetDefinition[];
  trackingPageTitle?: string;
};

function WidgetTabGroup({ widgets, trackingPageTitle = '' }: Props) {
  const tabs = useMemo(
    () =>
      widgets.map(
        (widget): Tab => ({
          label: widget.description || 'Tab',
          content: (
            <WidgetRenderer
              isGroupedByTabView
              key={widget.id}
              widget={widget}
            />
          ),
          key: widget.id,
        }),
      ),
    [widgets],
  );

  return <TabView trackingPageTitle={trackingPageTitle} tabs={tabs} />;
}

export default WidgetTabGroup;
